import React from 'react';
import classNames from 'classnames';
import { CharacterCount as DNACharacterCount } from '@justgiving/dna-form';

interface Props {
  id: string;
  value: string;
  label: string;
  fieldClass: string;
  labelClass: string;
  inputClass: string;
  isLabelHidden: boolean;
  hasCharacterCount: boolean;
  hasCharacterCountTrim: boolean;
  maxLength: number;
  autoResize: boolean;
  handleBlur: () => void;
}

class Textarea extends React.Component<Props> {
  text: HTMLTextAreaElement;
  characterCount: typeof DNACharacterCount;

  componentDidMount() {
    const { hasCharacterCount, maxLength, hasCharacterCountTrim } = this.props;

    if (hasCharacterCount) {
      this.characterCount = new DNACharacterCount({
        el: this.text,
        maxLength,
        trimInput: hasCharacterCountTrim,
      });
    }
  }

  componentDidUpdate() {
    if (this.props.value === '' && this.characterCount) {
      this.characterCount = new DNACharacterCount({
        el: this.text,
        maxLength: this.props.maxLength,
        trimInput: this.props.hasCharacterCountTrim,
      });
    }
  }

  resize = () => {
    this.text.style.height = 'auto';
    this.text.style.height = `${this.text.scrollHeight + 8}px`;
  };

  delayedResize = () => {
    setTimeout(this.resize, 0);
  };

  renderInput() {
    const {
      value,
      hasCharacterCount,
      inputClass,
      autoResize,
      id,
      maxLength,
    } = this.props;
    const inputClassName = classNames('dna-textarea', inputClass, {
      'js-dna-character-count': hasCharacterCount,
    });

    if (autoResize) {
      return (
        <textarea
          className={inputClassName}
          ref={r => {
            this.text = r as HTMLTextAreaElement;
          }}
          value={value}
          id={id}
          maxLength={maxLength}
          onCut={this.delayedResize}
          onPaste={this.delayedResize}
          onDrop={this.delayedResize}
          onKeyDown={this.delayedResize}
          onBlur={this.props.handleBlur}
        />
      );
    }

    return (
      <textarea
        className={inputClassName}
        ref={r => {
          this.text = r as HTMLTextAreaElement;
        }}
        value={value}
        id={id}
        maxLength={maxLength}
        onBlur={this.props.handleBlur}
      />
    );
  }

  render() {
    const { id, label, fieldClass, labelClass, isLabelHidden } = this.props;
    const fieldClassName = classNames('dna-form-field', fieldClass);
    const labelClassName = classNames('dna-label', labelClass, {
      'dna-invisible': isLabelHidden,
    });

    return (
      <div className={fieldClassName}>
        <label className={labelClassName} htmlFor={id}>
          {label}
        </label>
        {this.renderInput()}
      </div>
    );
  }
}

export default Textarea;



// WEBPACK FOOTER //
// ./src/components/dna/Textarea.tsx